import { EventOwner } from '@/pages/admin/event_owners/index.page'

export interface Category {
  id: string
  name: string
}

export interface Event {
  id?: string
  key: string
  name: string
  slug?: string
  description: string
  attended?: number
  start_date: string
  start_time: string | null
  end_date: string
  end_time: string | null
  client_name: string
  status: 'draft' | 'live' | 'archived' | 'purged' | 'deleted'
  category?: string
  categories?: Category[]
  category_ids?: string[]
  owner?: string
  owners?: EventOwner[]
  owner_ids?: string[]
  registered?: number
  pending_approval?: number
  approved?: number
  location?: string
  allow_attendee_app_access: boolean
  allow_public_registration: boolean
  theme: 'black' | 'grey' | 'slate' | 'darkblue' | 'blue' | 'pink' |
         'darkred' | 'red' | 'darkorange' | 'orange' | 'darkgreen' | 'green'
  logo?: string | null
  banner?: string | null
}

export type EventStatus = Event['status']

export const EVENT_STATUS_LABELS: Record<EventStatus, string> = {
  draft: 'Draft',
  live: 'Live',
  archived: 'Archived',
  purged: 'Purged',
  deleted: 'Deleted',
}
